import React from 'react'
import type {CategoryData} from '../data/types'

interface SwitchingDestinationsProps {
  data: CategoryData
}

const SwitchingDestinations: React.FC<SwitchingDestinationsProps> = ({data}) => {
  const max = Math.max(...data.switching.rows.map((r) => r.switchIns))

  return (
    <section className="section white">
      <div className="wrap">
        <div className="subsection">
          <div className="sub-eyebrow">Switching destinations</div>
          <h3>Who's winning switchers in {data.label}.</h3>
          <p className="sub-intro">
            {data.switching.intro} After dropping a vendor, these ones stayed on the bill or got added.
          </p>
          <div className="cat-switching">
            <div className="destination-list">
              {data.switching.rows.map((r) => {
                const pct = (r.switchIns / max) * 100
                return (
                  <div key={r.name} className="row">
                    <div className="rank">{r.rank}</div>
                    <div className="name">{r.name}</div>
                    <div className="bar">
                      <span style={{width: `${pct}%`}} />
                    </div>
                    <div className="v">
                      <strong>{r.switchIns}</strong> customers won · from {r.from} rivals
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SwitchingDestinations
